module.exports = __webpack_public_path__ + "img/NO.d3b5b53a.svg";